var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2,16.6c-2.8,0-5.7,0-8.5,0c-1.1,0-1.7-0.7-1.7-1.7C0,13,0,11,0,9.1C0,8,0.6,7.4,1.7,7.4c2.9,0,5.7,0,8.5,0 c0.2,0,0.3,0,0.5,0c0-0.1,0-0.3,0-0.4c0-1.3,0-2.6,0-3.9c0-0.7,0.3-1.2,0.9-1.5c0.6-0.3,1.2-0.1,1.7,0.3c3.3,3,6.7,5.9,10.1,8.8 c0.8,0.8,0.8,1.8,0,2.5c-3.4,3-6.7,5.9-10.1,9c-0.3,0.2-0.6,0.4-0.9,0.4c-1,0.1-1.7-0.5-1.7-1.6c0-1.3,0-2.6,0-3.9 c0-0.2,0-0.3,0-0.5C10.5,16.6,10.3,16.6,10.2,16.6z M22.5,12C19,9,15.7,6.1,12.2,3.1c0,0.3,0,0.4,0,0.6c0,1.5,0,2.9,0,4.4 C12.2,8.7,12,9,11.3,9C8.2,9,5.2,9,2.1,9C1.9,9,1.8,9,1.6,9c0,2.1,0,4.1,0,6.1c0.2,0,0.4,0,0.5,0c3,0,6.1,0,9.1,0c0.6,0,1,0.2,1,1 c0,1.5,0,3,0,4.5c0,0.1,0,0.2,0,0.4C15.6,18,19,15,22.5,12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.0026f83b6a539c9cc633344088b609d2.svg";
export { ForwardRef as ReactComponent };